import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { CourseTerm } from '../../../student360/student-schedule/course-term.model';
import { TeacherPreview } from './teacher-preview.model';
export class ReportParameterV9 {
    IsCriteriaChange: boolean;
    ReportTitle: string;
    isValueChange: boolean;
    isReportList: boolean;
    PrintDate: string;
    AttendanceDate = '';
    FromPeriod: number;
    ToPeriod: number;
    Week1Date = '';
    Week2Date = '';
    TermId: number;
    radValue: string;
    SkipLineBetweenStudent = false;
    PrintWithGreyHeading = false;
    PrintStudentAbsencesAlreadyEntered = false;
    PrintTeacherSignatureLine = false;
    OtherFields: Lookup[];
    Terms: CourseTerm[];
    OtherField: string;
    Select: boolean;
    ReportGridData: TeacherPreview[];
    selectAllReportGridData: boolean;
    PrintAdds = false;
    PrintComment = false;

    AddTermAll() {
        const term = new CourseTerm();
        term.Id = 0;
        term.LongDescription = ' All Terms';
        this.Terms.push(term);
    }



}
